import { createContext } from 'react';

const defaultState = {
  ruleTypeId: null,
  count: null,
  term: '',
};

const GridContext = createContext(defaultState);

export default GridContext;
